import React, { useState, useEffect } from "react";
import axios from "axios";
import API_URL from "../config";

const SkeletonCard = () => (
  <div className="bg-gray-900/40 border border-gray-800 rounded-xl p-6 sm:p-8 animate-pulse">
    <div className="h-4 bg-gray-700 rounded w-3/4 mb-3"></div>
    <div className="h-4 bg-gray-700 rounded w-5/6 mb-3"></div>
    <div className="h-4 bg-gray-700 rounded w-2/3 mb-5"></div>
    <div className="h-4 bg-gray-700 rounded w-1/4 mb-1.5"></div>
    <div className="h-3 bg-gray-700 rounded w-1/3"></div>
  </div>
);

const Testimonial = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/testimonials`)
      .then((response) => {
        setTestimonials(response.data || []);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message || "Failed to load testimonials.");
        setLoading(false);
      });
  }, []);

  return (
    <div className="bg-black text-white py-10 sm:py-20 lg:py-20">
      <div className="max-w-6xl mx-auto px-6">
        {/* Section header */}
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-gray-400 mb-3 sm:mb-4">
            Voices
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-thin leading-snug">
            What Our <em>Clients Say</em>
          </h2>
          <p className="text-sm sm:text-base md:text-lg font-light leading-relaxed max-w-3xl mx-auto text-gray-300 mt-6 sm:mt-8">
            Hear from business owners and professionals who are scaling and boosting productivity with AI.
          </p>
        </div>

        {/* Error state */}
        {error && (
          <div className="text-center text-sm sm:text-base text-red-400 bg-red-900/20 border border-red-700/40 rounded-lg py-4 px-4 mb-8">
            Error loading testimonials: {error}
          </div>
        )}

        {/* Content / Loading / Empty state */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 sm:gap-12">
          {loading ? (
            [...Array(3)].map((_, index) => <SkeletonCard key={index} />)
          ) : testimonials.length === 0 ? (
            <p className="col-span-full text-center text-gray-400 text-sm sm:text-base">
              No testimonials available at the moment.
            </p>
          ) : (
            testimonials.map((testimonial, index) => (
              <div
                key={testimonial.id || testimonial._id || `${testimonial.name}-${index}`}
                className="text-center"
              >
                <div className="mb-6 sm:mb-8">
                  <div className="text-3xl sm:text-4xl font-thin text-gray-700 mb-4 sm:mb-6">
                    "
                  </div>
                  <blockquote className="text-sm sm:text-base md:text-lg font-light leading-relaxed text-gray-300 mb-6 sm:mb-8">
                    {testimonial.feedback}
                  </blockquote>
                </div>
                <div className="w-12 h-px bg-white mx-auto mb-3 sm:mb-4"></div>
                <p className="text-[11px] sm:text-xs tracking-[0.2em] uppercase text-gray-400 mb-1">
                  {testimonial.name}
                </p>
                <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-gray-500">
                  {testimonial.role}
                </p>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
